import Vue from 'vue'
import VueI18n from 'vue-i18n'

const dateTimeFormats = {
    'en': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric', second: 'numeric'
        }
    },
    'pt': {
        short: {
            year: 'numeric', month: 'numeric', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric', second: 'numeric'
        }
    },
    'es': {
        short: {
            year: 'numeric', month: 'numeric', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric', second: 'numeric'
        }
    }
}

const numberFormats = {
    'usd': {
        currency: {
            style: 'currency', currency: 'USD', currencyDisplay: 'symbol'
        },
        currencyShort: {
            style: 'currency', currency: 'USD', currencyDisplay: 'symbol', maximumFractionDigits: 0, minimumFractionDigits: 0
        },
        percent: {
            style: 'percent'
        }
    },
    'brl': {
        currency: {
            style: 'currency', currency: 'BRL', currencyDisplay: 'symbol'
        },
        currencyShort: {
            style: 'currency', currency: 'BRL', currencyDisplay: 'symbol', maximumFractionDigits: 0, minimumFractionDigits: 0
        },
        percent: {
            style: 'percent'
        }
    },
    'eur': {
        currency: {
            style: 'currency', currency: 'EUR', currencyDisplay: 'symbol'
        },
        currencyShort: {
            style: 'currency', currency: 'EUR', currencyDisplay: 'symbol', maximumFractionDigits: 0, minimumFractionDigits: 0
        },
        percent: {
            style: 'percent'
        }
    }
}

const datepicker = {
    'en': {
        now: 'now',
        today: 'today',
        cancel: 'cancel',
        clear: 'clear',
        confirm: 'confirm',
        selectDate: 'selectDate',
        selectTime: 'selectTime',
        startTime: 'startTime',
        endTime: 'endTime',
        year: 'year',
        month: 'Month',
        week: 'week',
        weeks: {
            sun: 'sun',
            mon: 'mon',
            tue: 'tue',
            wed: 'wed',
            thu: 'thu',
            fri: 'fri',
            sat: 'sat'
        },
        months: {
            jan: 'jan',
            feb: 'feb',
            mar: 'mar',
            apr: 'apr',
            may: 'may',
            jun: 'jun',
            jul: 'jul',
            aug: 'aug',
            sep: 'sep',
            oct: 'oct',
            nov: 'nov',
            dec: 'dec'
        }
    },
    'pt': {
        now: 'now',
        today: 'today',
        cancel: 'cancel',
        clear: 'clear',
        confirm: 'confirm',
        selectDate: 'selectDate',
        selectTime: 'selectTime',
        startTime: 'startTime',
        endTime: 'endTime',
        year: 'year',
        month: 'Month',
        week: 'week',
        weeks: {
            sun: 'sun',
            mon: 'mon',
            tue: 'tue',
            wed: 'wed',
            thu: 'thu',
            fri: 'fri',
            sat: 'sat'
        },
        months: {
            jan: 'jan',
            feb: 'feb',
            mar: 'mar',
            apr: 'apr',
            may: 'may',
            jun: 'jun',
            jul: 'jul',
            aug: 'aug',
            sep: 'sep',
            oct: 'oct',
            nov: 'nov',
            dec: 'dec'
        }
    },
    'es': {
        now: 'now',
        today: 'today',
        cancel: 'cancel',
        clear: 'clear',
        confirm: 'confirm',
        selectDate: 'selectDate',
        selectTime: 'selectTime',
        startTime: 'startTime',
        endTime: 'endTime',
        year: 'year',
        month: 'Month',
        week: 'week',
        weeks: {
            sun: 'sun',
            mon: 'mon',
            tue: 'tue',
            wed: 'wed',
            thu: 'thu',
            fri: 'fri',
            sat: 'sat'
        },
        months: {
            jan: 'jan',
            feb: 'feb',
            mar: 'mar',
            apr: 'apr',
            may: 'may',
            jun: 'jun',
            jul: 'jul',
            aug: 'aug',
            sep: 'sep',
            oct: 'oct',
            nov: 'nov',
            dec: 'dec'
        }
    }
}

Vue.use(VueI18n)

function loadLocaleMessages () {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'pt',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'pt',
    silentTranslationWarn: true,
    messages: loadLocaleMessages(),
    dateTimeFormats,
    numberFormats,
    datepicker
})
